<template>
  <footer class="the-footer flex-wrap justify-between " style="margin-top: -35px;">
    <span>© {{ new Date().getFullYear() }}  Bitrack. All rights reserved</span>
    <!--<span class="md:flex hidden items-center">-->
    <!--<span>Hand-crafted & Made with</span>-->
    <!--<feather-icon icon="HeartIcon" svgClasses="stroke-current text-danger w-6 h-6" class="ml-2" />-->
    <!--</span>-->
  </footer>
</template>

<script>
export default {
  name: "the-footer",
  props: {
    classes: {
      type: String,
    },
  }
}
</script>
